<template>
  <div>
    <v-toolbar
      :style="$vuetify.breakpoint.mdAndUp ? 'color:white' : 'color:white'"
      flat
      color="primary"
      dark
      dense
      v-if="ttMarcasNew.length != 0"
    >
      <v-row>
        <v-col>
          <span
            :class="[
              {
                'body-2 ml-2 font-weight-medium': $vuetify.breakpoint.smAndDown,
              },
              { 'font-weight-medium  title ml-0': $vuetify.breakpoint.mdAndUp },
            ]"
          >
            Marcas Disponibles
          </span>
        </v-col>
      </v-row>
    </v-toolbar>
    <v-skeleton-loader
      v-if="ttMarcasNew.length === 0"
      fade-transition
      height="94"
      type="list-item-three-line"
    >
    </v-skeleton-loader>
    <v-card class="d-flex justify-start ma-1 font-weight-medium" flat tile>
      <v-radio-group v-model="radioGroup" row>
        <v-radio
          :disabled="radioGroup === item.Marca"
          @click="itemmarca(item.Marca)"
          class="ma-1"
          :class="[
            { 'font-weight-Black font-italic': radioGroup === item.Marca },
          ]"
          color="accent"
          v-for="item in ttMarcasNew"
          :key="`${item.Marca}`"
          :label="`${item.Nombre}`"
          :value="item.Marca"
        >
        </v-radio>
      </v-radio-group>
    </v-card>
    <v-divider color="accent"></v-divider>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
export default {
  name: "listaMarca",
  data() {
    return {
      radioGroup: null,
      row: null,
    };
  },

  watch: {
    CodMarcaPdf() {
      if (this.CodMarcaPdf === 0) this.radioGroup = null;
    },
  },
  props: {
    init: Number,
  },
  methods: {
    ...mapMutations(["set_CodMarcaPdf", "CLR_BUSCARMARCAtt"]),
    limpiaMarca() {
      this.CLR_BUSCARMARCAtt();
    },
    itemmarca(valor) {

      this.radioGroup = valor;
      this.set_CodMarcaPdf(valor);

    },
  },
  computed: {
    ...mapState(["imgMarcas", "ttMarcas", "CodMarcaPdf"]),
    marcaLogo: function () {
      return function (id) {
        return `${this.imgMarcas}${id}.jpg`;
      };
    },
    ttMarcasNew: {
      get: function () {
        if (this.ttMarcas) {
          return this.ttMarcas.filter((x) => x.Items != 0);
        }
      },
    },
  },
};
</script>

<style>
</style>